import { render } from "./AccountUpdateEmail.vue?vue&type=template&id=9c3aa534&ts=true"
import script from "./AccountUpdateEmail.vue?vue&type=script&lang=ts"
export * from "./AccountUpdateEmail.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__